<template>
    <v-app>
        <v-main>
            <v-container fluid class="fill-height pa-0">
                <v-row class="fill-height">
                    <v-col cols=12 md=7 class="navigation-part">
                        <router-view v-slot="{ Component }">
                            <transition name="fade" mode="out-in">
                                <component :is="Component" />
                            </transition>
                        </router-view>
                    </v-col>
                    <v-col cols="5" class="d-none d-md-block side-info-panel-background">
                        <info-panel />
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
	</v-app>
</template>

<script>

import InfoPanel from '@/components/info-panel/InfoPanel.vue';

export default {

    components: {
        InfoPanel,
    },

}

</script>

<style>

#app,
.v-application,
.v-application * {
    font-family: 'Nunito Sans', sans-serif !important;
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.navigation-part {
    max-height: 100vh;
    overflow-y: auto;
    padding-bottom: 80px!important;
}

/* Champs formulaire plus compacts (toutes étapes) */
.v-input--density-compact .v-field__input {
    min-height: 40px !important;
    padding-top: 4px !important;
}

.v-input--density-compact {
    --v-input-control-height: 40px;
}

.v-input--density-compact .v-field--variant-outlined,
.v-input--density-compact .v-field--variant-underlined {
    --v-field-padding-top: 6px;
    --v-field-padding-bottom: 4px;
}

/* Réserve l'espace du message d'erreur (évite le saut de layout) */
.v-input:not(.v-input--hide-details) .v-input__details {
    min-height: 26px;
    padding-top: 2px;
    padding-bottom: 4px;
    margin-bottom: 2px;
}

/* Accent doux sur boutons primary (charte or) */
.v-btn.bg-primary,
.v-btn--variant-elevated.bg-primary,
.v-theme--myCustomTheme .v-btn.bg-primary {
  box-shadow: inset 0 -3px 0 #f2cd78 !important;
}

/* Focus champs : petite touche rouge charte */
.v-field--focused .v-field__outline {
  --v-field-border-opacity: 1;
  color: #a9343f;
}

.v-field--focused.v-field--variant-underlined .v-field__outline::after {
  border-color: #a9343f;
}

.side-info-panel-background {
    background-image: url(./assets/panel-info-background.jpg);
    background-size: cover;
    background-position: center;
    position: relative;
    max-height: 100vh;
    overflow-y: auto;
}

.side-info-panel-background::after {
    content: '';
    display: block;
    position: fixed;
    width: 41.6%;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #06113a;
    opacity: 0.8;
}

</style>
